<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">升级状态</div>
                </div>
                <div class="xc-modal-body">
                    <!-- <div class="xc-info">
                        <div class="xc-info-content">
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    升级统计信息：升级成功{{info.successNum}}个，升级失败{{info.failedNum}}个，升级中{{info.doingNum}}个
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <form
                        name="publish"
                        class="xc-form"
                    >
                        <div class="xc-form-inline">
                            <xc-form-item label="面板名称:">
                                <input
                                    type="text"
                                    class="xc-input"
                                    placeholder="请输入面板名称"
                                    v-model="mix_query.panelName"
                                >
                            </xc-form-item>
                            <xc-form-item label="面板编码:">
                                <input
                                    type="text"
                                    class="xc-input"
                                    placeholder="请输入面板编码"
                                    v-model="mix_query.panelCode"
                                >
                            </xc-form-item>
                            <div class="xc-btn-group">
                                <button
                                    type="submit"
                                    class="xc-btn xc-btn-primary"
                                    @click.prevent="mix_search"
                                >查询
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="xc-row-scroll">
                        <table class="xc-table">
                            <thead>
                                <th>门店名称</th>
                                <th>房间名称</th>
                                <th>面板MAC</th>
                                <th>面板IP</th>
                                <th>面板名称</th>
                                <th>面板编码</th>
                                <th>升级状态</th>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>
                                            {{item.storeName}}
                                        </td>
                                        <td>
                                            {{item.roomName}}
                                        </td>
                                        <td>
                                            {{item.panelMac}}
                                        </td>
                                        <td>
                                            {{item.externalIp}}
                                        </td>
                                        <td>
                                            {{item.panelName}}
                                        </td>
                                        <td>
                                            {{item.panelCode}}
                                        </td>
                                        <td>
                                            {{item.upgradeSuccessDesc}}
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="xc-modal-footer xc-flex-item">
                    <div class="xc-btn-group">
                        <button
                            type="button"
                            class="xc-btn xc-btn-default"
                            @click="close"
                        >关闭</button>
                    </div>
                    <!-- 分页 -->
                    <xc-pagination
                        @change="mix_pageChange"
                        :page="mix_page"
                        :total="mix_total"
                        :size="mix_pageSize"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import myLayerImport from "@/libs/myLayer"
import devicePanelApi from '../api/devicePanel';
import '@/utils/ip-format';

export default {
    name: 'DevicePanelDetail',
    mixins: [listMixin],
    data() {
        return {
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'programVersion',

            // 默认查询参数
            mix_query: {

            },

            // 列表数据
            list: [],


            info: {},
        }
    },
    methods: {
        // 列表初始化数据
        initData() {

            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                panelApkId: this.$route.params.panelApkId,
                ...this.mix_query,
            }

            devicePanelApi.getApkUpgradePanelList({params:search}).then(ret => {
                //添加mix_checkbox属性
                this.list = this.mix_format(ret.data.list);
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            })
        },
        close: function () {
            parent.myLayer.close(this.index);
        },
    },
    async mounted() {
        await myLayerImport();
        this.index = parent.myLayer.getFrameIndex(window.name);
    },
    created() {
        devicePanelApi.getApkById({params:{
            panelApkId: this.$route.params.panelApkId,
        }}).then(v => {
            this.info = v.data;
        })
    }
}
</script>

<style scoped lang="scss">
.xc-row {
    margin-bottom: 0;
}
.xc-page-footer {
    border-top: 1px solid #eef2f9;
}
</style>
